import { render, staticRenderFns } from "./EditAttachments.vue?vue&type=template&id=2b38b226&scoped=true&"
import script from "./EditAttachments.vue?vue&type=script&lang=js&"
export * from "./EditAttachments.vue?vue&type=script&lang=js&"
import style0 from "./EditAttachments.vue?vue&type=style&index=0&id=2b38b226&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b38b226",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b38b226')) {
      api.createRecord('2b38b226', component.options)
    } else {
      api.reload('2b38b226', component.options)
    }
    module.hot.accept("./EditAttachments.vue?vue&type=template&id=2b38b226&scoped=true&", function () {
      api.rerender('2b38b226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/EditAttachments.vue"
export default component.exports